import React from 'react';
import './App.css';
import GlobalStyle from 'const/style/GlobalStyle';
import {CSSTransition} from "react-transition-group";
import TransitionFrame from "./components/TransitionFrame";
import PresentationPlay from "./pages/PresentationPlay";
import PTInformation from "./models/PTInformation";

function App() {
    const ptInformation = new PTInformation();
    return (
        <div className="App">
            <GlobalStyle/>
            <TransitionFrame>
                <CSSTransition
                    classNames='fade'
                    timeout={500}
                >
                    <PresentationPlay ptInformation={ptInformation}/>
                </CSSTransition>
            </TransitionFrame>
        </div>
    );
}

export default App;